// src/components/ui/Card.js
import React from 'react';

// Main Card container with shadow and rounded corners
export const Card = ({ children, className }) => (
  <div className={`rounded-lg shadow-lg bg-white p-4 ${className}`}>
    {children}
  </div>
);

// CardHeader for the header section, usually with a border at the bottom
export const CardHeader = ({ children, className }) => (
  <div className={`border-b pb-2 mb-4 ${className}`}>{children}</div>
);

// CardTitle for displaying a title, styled as a heading
export const CardTitle = ({ children, className }) => (
  <h2 className={`text-2xl font-semibold ${className}`}>{children}</h2>
);

// CardContent for the content area inside the card
export const CardContent = ({ children, className }) => (
  <div className={className}>{children}</div>
);
